module.exports = __webpack_public_path__ + "img/ic_goumai.653dbcc7.png";